/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var PriceFromEnum;

(function (PriceFromEnum) {
  PriceFromEnum["MANUAL"] = "manual";
  PriceFromEnum["API"] = "api";
})(PriceFromEnum || (PriceFromEnum = {}));